import React from "react";
import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import FormCheckboxField from "../../fields/checkboxField";
import DynamicFieldLabel from "./DynamicFieldLabel";
import { useDynamicFormRenderer } from "../context/dynamicFormRendererContext";

/**
 * @name CheckboxFieldWrapper to render checkbox field from dynamic schema
 * @param props
 */
export default function CheckboxFieldWrapper(props: DynamicFieldConfigType) {
  const customData = useDynamicFormRenderer();
  return (
    <React.Fragment>
      <FormCheckboxField
        name={props.schemaObj.id}
        label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
        disabled={props.schemaObj.disabled}
        required={props.schemaObj.mandatory}
        validate={props.validationFn}
        conflictValue={props.schemaObj.conflictValue}
        className={props.schemaObj.className}
        fullWidth={customData.useCheckBoxFullWidthViewFromApi ? props.schemaObj.fullWidthView : true}
        indented={props.schemaObj.indented}
      />
    </React.Fragment>
  );
}
